import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicPhoneMobile({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.5.75c.97 0 1.75.78 1.75 1.75v11c0 .97-.78 1.75-1.75 1.75h-7c-.97 0-1.75-.78-1.75-1.75v-11c0-.97.78-1.75 1.75-1.75h7zm0 1.5h-7a.25.25 0 00-.25.25v11c0 .14.11.25.25.25h7c.14 0 .25-.11.25-.25v-11a.25.25 0 00-.25-.25zM8 5a1 1 0 100-2 1 1 0 000 2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicPhoneMobile.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicPhoneMobile.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicPhoneMobile svgRef={ref} {...props} />
));
export default ForwardRef;
